import * as AuthApi from './AuthApi';
import AuthConstants from './AuthConstants';

const loggedIn = (user) => ({
    type: AuthConstants.AUTH_LOGGED_IN,
    payload: {
        id: user.id,
        name: user.name,
        email: user.email
    }
});

const loggedOut = () => ({
    type: AuthConstants.AUTH_LOGGED_OUT,
});

// ---

export function login(email, password, remember) {
    return function (dispatch) {
        return AuthApi.login(email, password, remember).then(user => {
            dispatch(loggedIn(user));

            return user;
        });
    };
}

export function fetchCurrentUser() {
    return function (dispatch) {
        return AuthApi.user().then(user => {
            if (user) {
                dispatch(loggedIn(user));
            }

            return user;
        });
    };
}

export function logout() {
    return function (dispatch) {
        dispatch(loggedOut());

        return AuthApi.logout();
    };
}

export function signUp({firstname, lastname, email, organisation}) {
    return function (dispatch) {
        return AuthApi.signup(firstname, lastname, email, organisation);
    }
}
